<template>
  <div>
    <v-file-input
        accept="image/*"
        :label="label ? label : '사진'"
        v-model="file"
        @change="processAndUploadFile"
        @click:clear="resetFile"
    ></v-file-input>
    <slot></slot>
    <v-img
        contain
        transition="scale-transition"
        :src="tempImgUrl ? tempImgUrl : require('@/assets/images/RequestImage.svg')"
    >
    </v-img>
  </div>
</template>

<script>

import {getImgMetadata} from "@/firebase/firestorage";

export default {
  name: "ImageUpload",
  props: {
    label: String,
    imgUrl: String,
    fullPath: String,
    appendOuterIcon: Boolean,
  },
  created() {
    if (this.imgUrl && this.fullPath) this.urlToFile(this.imgUrl, this.fullPath)
  },
  watch: {
    // images that has fullPath are images that are already uploaded to firestore
    async fullPath() {
      if (this.imgUrl && this.fullPath) await this.urlToFile(this.imgUrl, this.fullPath)
      if (!this.fullPath) this.resetFile()
    }
  },
  data: () => ({
    file: null,
    tempImgUrl: null,
  }),
  methods: {
    async processAndUploadFile() {
      if (!this.file) {
        return
      }

      const resizedImage = await this.resizeImage({file: this.file, maxSize: 2000})
      const fileToUpload = this.file.size > resizedImage.size ? resizedImage : this.file
      let tempImgUrl = this.file.size > resizedImage.size ? URL.createObjectURL(resizedImage) : URL.createObjectURL(this.file)
      this.tempImgUrl = tempImgUrl
      this.$emit('imgUploaded', {file: fileToUpload, tempImgUrl: tempImgUrl})
    },
    resetFile() {
      this.file = null
      this.tempImgUrl = null
    },
    // create a File object if there is source image
    async urlToFile(url, fullPath) {
      try {
        const response = await fetch(url)
        if (!response) return

        const data = await response.blob()

        const imgMetadata = await getImgMetadata(fullPath)
        if (!imgMetadata) return null

        const option = {
          'type': imgMetadata.contentType
        }
        const imgName = imgMetadata.name
        this.file = new File([data], imgName, option)
        await this.processAndUploadFile()
      } catch (e) {
        // situation 1) Specified file has been deleted from firestore
        // situation 2) Specified file is being resized
      }
    },
    resizeImage(settings) {
      let file = settings.file;
      if (!file) return new Promise((resolve, reject) => reject("No file to resize"))

      let maxSize = settings.maxSize;
      let reader = new FileReader();
      let image = new Image();
      let canvas = document.createElement('canvas');
      let dataURItoBlob = function (dataURI) {
        let bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
            atob(dataURI.split(',')[1]) :
            unescape(dataURI.split(',')[1]);
        let mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        let max = bytes.length;
        let ia = new Uint8Array(max);
        for (let i = 0; i < max; i++)
          ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], {type: mime});
      };
      let resize = function () {
        let width = image.width;
        let height = image.height;
        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/jpeg');
        return dataURItoBlob(dataUrl);
      };
      return new Promise(function (ok, no) {
        if (!file.type.match(/image.*/)) {
          no(new Error("Not an image"));
          return;
        }
        reader.onload = function (readerEvent) {
          image.onload = function () {
            return ok(resize());
          };
          image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
      });
    }
  }
}
</script>

<style scoped>

</style>